import SequenceTagsFilter from 'crono-fe-common/components/SequencePicker/SequenceTagsFilter';
import ExternalPropertyFilter from 'crono-fe-common/types/externalPropertyFilter';
import useGetExternalProperty from 'hooks/services/externalProperty/useGetExternalProperty';

interface SequenceTagsFilterContainerProps {
  filterExternalProperties: ExternalPropertyFilter[];
  setFilterExternalProperties: (value: ExternalPropertyFilter[]) => void;
}

const SequenceTagsFilterContainer = ({
  filterExternalProperties,
  setFilterExternalProperties,
}: SequenceTagsFilterContainerProps) => {
  const { data: externalProperties } = useGetExternalProperty({
    tableType: null,
    onlyTag: true,
  });

  return (
    <SequenceTagsFilter
      externalProperties={externalProperties?.data?.data ?? []}
      filterExternalProperties={filterExternalProperties}
      setFilterExternalProperties={setFilterExternalProperties}
    />
  );
};

export default SequenceTagsFilterContainer;
